<template>
  <div id="demo-basic-card">

    <div id="module-data">
        <div id="editPackageLoadingDiv" class="vs-con-loading__container">
            <vx-card :title="packageName" class="mb-base" style="min-height: 600px;">
                <form data-vv-scope="editPackageForm">
                    <div class="vx-row">
                        <div class="vx-col sm:w-full w-full mb-2">
                            Package name
                            <vs-input v-validate="'required'" name="name" ref="name" class="w-full" label="" v-model="package_data.name" />
                            <span class="text-danger text-sm" v-show="errors.has('editPackageForm.name')">{{ errors.first('editPackageForm.name') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-2">
                        <div class="vx-col sm:w-full w-full mb-4">
                            <vs-input v-validate="'min:1|max_value:1000000'" name="price" ref="price" class="w-full" label="Cost" v-model="package_data.price" />
                            <span class="text-danger text-sm" v-show="errors.has('editPackageForm.price')">{{ errors.first('editPackageForm.price') }}</span>
                        </div>
                    </div>

                    <div class="vx-row mt-base">
                        <div class="vx-col w-full mb-2">
                            Description
                            <vs-textarea v-model="package_data.description" />
                        </div>
                    </div>

                    <div class="vx-row mt-2">
                        <div class="vx-col  w-full mb-4">
                            <div id="viewTestsLoadingDiv" class="vs-con-loading__container">
                                <div class="vx-col w-full mb-4">
                                    Tests / Lessions
                                    <vs-table 
                                        max-items="20"
                                        @change-page="handleChangePage"
                                        @sort="handleSort"
                                        :data="testsData">

                                        <template slot="thead">
                                            <vs-th>Id</vs-th>
                                            <vs-th>Image</vs-th>
                                            <vs-th>Test name</vs-th>
                                            <vs-th>Test Type</vs-th>
                                            <!-- <vs-th>Max attempts</vs-th> -->
                                        </template>

                                        <template slot-scope="{data}">
                                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                                <vs-td :data="data[indextr].id">
                                                    <vs-checkbox :vs-value="data[indextr].id" :value="data[indextr]" v-model="selected"></vs-checkbox>
                                                </vs-td>
                                                <vs-td :data="data[indextr].picture">
                                                    <img width="80" :src="data[indextr].picture" alt="content-img">
                                                </vs-td>
                                                <vs-td :data="data[indextr].name">
                                                    {{data[indextr].name}}
                                                </vs-td>
                                                <vs-td :data="data[indextr].module_type">
                                                    {{data[indextr].module_type == "lession" ? "Lession" : "Teori"}}
                                                </vs-td>
                                                <!-- <vs-td>
                                                    <vs-input v-validate="'numeric'" :name="'attempts_'+indextr" :ref="'attempts_'+indextr" class="w-full" label="" v-model="data[indextr].max_attempts" />
                                                    <span class="text-danger text-sm" v-show="errors.has('editPackageForm.attempts_'+indextr)">{{ errors.first('editPackageForm.attempts_'+indextr) }}</span>
                                                </vs-td> -->
                                            </vs-tr>
                                        </template>
                                    </vs-table>

                                    <div class="vx-row mt-base">
                                        <div class="vx-col w-full mb-2">
                                            <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full"  align="right">
                          <vs-button @click="validateCreatePackage()" class="mr-3 mb-2">Edit package</vs-button>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default{
    data() {
        return {
            package_data: {
                name : null,
                price : null,
                special_price : null,
                description : null,
                price_type : 'free',
            },
            package_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            modules_values : [],
            modules_options : [],
            otherModuleType_ : null,
            packageName : null,
            search : null,
            totalPage: 1,
            currentPage: 1,
            selected:[],
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
        vSelect,
        Treeselect,
    },
    computed: {
        priceType: {
            set: function(val) {
                this.package_data.price_type = val.toLowerCase();
            },
            get: function() {
                let type = this.package_data.price_type
                return type[0].toUpperCase() + type.slice(1);
            }
        },
        testsData() {
            return this.$store.state.questionManagement.tests
        },
    },
    methods: {
        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchTests()
            }, 2000);   
        },
        handleChangePage(page) {
            // this.searchUser()
        },
        handleSort(key, active) {
            if(key){
                this.key = key
                this.active = active
                this.searchTests()
            }
        },
        async searchTests() {
            var self = this
            this.$vs.loading({
                container: '#viewTestsLoadingDiv',
                scale: 0.6
            })

            let data = { 
                lang : this.test_data.lang, 
                page : this.currentPage,
            }

            await this.$store.dispatch("questionManagement/getAllQuestions", data)
                .then(res => { 
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                })
          
        },
        redirectToAllPackages() {
            this.$router.push("/packages").catch(() => {})
        },
        validateCreatePackage() {
            this.$validator.validateAll('editPackageForm').then(result => {
                if (result){
                    if(this.selected.length) this.createPackage();
                    else{
                        console.log(result)
                        this.$vs.notify({
                          time:4000,
                          title:'Error',
                          text: "Please select tests.",
                          color:'warning',
                          iconPack: 'feather',
                          icon:'icon-alert-circle'
                        });
                    }
                }
                else console.log(this.errors)
            })
        },
        createPackage() {
            console.log(this.selected)
            var self = this
            var attempts = [];
            var theoryTest = [];
            var theoryLessions = [];

            this.$vs.loading({
                container: '#editPackageLoadingDiv',
                scale: 0.6
            })

            let packageData = this.package_data
            
            for (var i = 0; i < this.selected.length; i++) {
                var currentTest = this.testsData.find(item => item.id === this.selected[i]);
                // console.log(this.selected)
                // console.log(currentTest)
                if(currentTest && currentTest.module_type == "lession" ) theoryLessions.push(this.selected[i])
                else theoryTest.push(this.selected[i])

                // theoryTest.push(this.selected[i])
                // attempts.push({
                //     test_id : this.selected[i],
                //     max_attempts : this.selected[i].max_attempts,
                //     min_attempts : this.selected[i].min_attempts,
                // })
            }

            packageData.price = this.package_data.price ? Math.round(this.package_data.price)  : 0;
            packageData.attempts = attempts;
            packageData.theory_test = theoryTest;
            packageData.theory_lesson = theoryLessions;
            packageData.test_package_id = this.package_data.id;


            this.$store.dispatch("questionManagement/updatePackage", packageData)
            .then(res => { 
                this.$vs.loading.close('#editPackageLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                  time:4000,
                  title:'Success',
                  text: 'Package successfully updated.',
                  color:'success',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'
                });

                // if(res.status == 201){
                //     this.$router.push("/packages/edit/" + res.data.package.id).catch(() => {})
                // }
            })
            .catch(err => {
                this.$vs.loading.close('#editPackageLoadingDiv > .con-vs-loading')

                if(err.status && err.status == 422){
                    Object.keys(err.data).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            msg: err.data[key][0],
                        });
                    });
                }
            })
        },
    },
    mounted(){
        this.$vs.loading({
            container: '#editPackageLoadingDiv',
            scale: 0.6
        })

        const packageId = this.$route.params.packageId
        this.$store.dispatch("questionManagement/viewPackage", packageId)
            .then(res => { 
                this.package_data = res.data 
                let theoryTest = res.data.theory_test ? res.data.theory_test : [];
                let theoryLesson = res.data.theory_lesson ? res.data.theory_lesson : [];
                this.selected = theoryLesson.concat(theoryTest); 
                this.$vs.loading.close('#editPackageLoadingDiv > .con-vs-loading')

            })
            .catch(err => {
                this.question_not_found = true
                this.$vs.loading.close('#editPackageLoadingDiv > .con-vs-loading')
            })
    },
    created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        this.$store.dispatch("questionManagement/getAllTests")
    },

}
</script>

